import axios from "axios";
import {
        GET_ALL_CERTIFICATED_PRODUCTS, 
        GET_ALL_CERTIFICATIONS,
        ADD_CERTIFICATE,
        GET_ALL_PRODUCTS,
        ADD_ASSIGN_CERTIFICATED_PRODUCTS,
        GET_SINGLE_PRODUCT_CERTIFICATE_DETAILS
       } from "../config/urlConfig";

// Function for fetch all certification product
export async function getAllCertificatedProductsApi(token, page, itemsPerPage) {
    try {
      const params =  new URLSearchParams();
      params.append('page',page)
      params.append('limit', itemsPerPage)
      let response = await axios.get(`${GET_ALL_CERTIFICATED_PRODUCTS}?${params.toString()}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });
  
      return response.data;
    } catch (error) {
      if (error?.response) {
        console.log(error.response.data);
  
        return error.response.data;
      }
      console.log(error.message);
    }
}

  
// Function for fetch all certification
export async function getAllCertificationsApi(token) {
    try {
    
      let response = await axios.get(GET_ALL_CERTIFICATIONS, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });
  
      return response.data;
    } catch (error) {
      if (error?.response) {
        console.log(error.response.data);
  
        return error.response.data;
      }
      console.log(error.message);
    }
}
  


// Function for fetch all products
export async function getAllProductsApi(token) {
  try {
  
    let response = await axios.get(GET_ALL_PRODUCTS, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    if (error?.response) {
      console.log(error.response.data);

      return error.response.data;
    }
    console.log(error.message);
  }
}

// Function for handling add certificate api
export async function handleAddCertificateApi(data, token) {
  try {
    let formData = new FormData();
    for (let key in data) {
      if (
        typeof data[key] === "object" &&
        data[key] !== null &&
        !(data[key] instanceof File)
      ) {
        // Convert object to a JSON string before appending
        formData.append(key, JSON.stringify(data[key]));
      } else {
        formData.append(key, data[key]);
      }
    }
    
    let response = await axios.post(ADD_CERTIFICATE, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  } catch (error) {
    if (error?.response) {
      console.log(error.response.data);

      return error.response.data;
    }
    console.log(error.message);
  }
}


export async function handleAddAssignedProductCertificateApi(data, token) {
  try {
    let formData = new FormData();
    for (let key in data) {
      if (
        typeof data[key] === "object" &&
        data[key] !== null &&
        !(data[key] instanceof File)
      ) {
        // Convert object to a JSON string before appending
        formData.append(key, JSON.stringify(data[key]));
      } else {
        formData.append(key, data[key]);
      }
    }
    
    let response = await axios.post(ADD_ASSIGN_CERTIFICATED_PRODUCTS, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  } catch (error) {
    if (error?.response) {
      console.log(error.response.data);

      return error.response.data;
    }
    console.log(error.message);
  }
}

// Function for fetch product relate certification details
export async function getProductRelateCertificationDetailsApi(token, id){
  try{
    
    let response = await axios.get(`${GET_SINGLE_PRODUCT_CERTIFICATE_DETAILS}/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });
    
    return response.data;
  }catch(error){
    if (error?.response) {
      console.log(error.response.data);

      return error.response.data;
    }
  }
}